export const STATUS = {
  on_track: {
    label: "On Track",
    bg: "bg-[#EFF3EE]",
    text: "text-[#42624B]",
    border: "border-[#C5D5C8]",
    fill: "bg-[#6F9775]",
    fillHex: "#6F9775",
    description: "Within hours and margin target.",
  },
  close_to_limit: {
    label: "Close to Limit",
    bg: "bg-[#FAF4E8]",
    text: "text-[#7A5E1F]",
    border: "border-[#E6D1A2]",
    fill: "bg-[#C99A4A]",
    fillHex: "#C99A4A",
    description: "Near included hours, or margin is low.",
  },
  losing_money: {
    label: "Losing Money",
    bg: "bg-[#FAEEED]",
    text: "text-[#7E332D]",
    border: "border-[#E7BFBA]",
    fill: "bg-[#C76055]",
    fillHex: "#C76055",
    description: "Over hours, or costs too much to service.",
  },
};

export const SERVICE_TYPES = [
  "Marketing",
  "SEO",
  "Social Media",
  "Content",
  "Design",
  "Web",
  "Branding",
  "Paid Ads",
  "Strategy",
  "Operations",
  "Other",
];

export const CURRENCY_SYMBOL = {
  USD: "$",
  CAD: "C$",
  GBP: "£",
  AUD: "A$",
  NZD: "NZ$",
  EUR: "€",
};

// Resolve which currency to use for a client. If client.currency is set, use it.
// Otherwise fall back to user/workspace settings.
export const clientCurrency = (client, fallback = "USD") =>
  (client?.currency || fallback || "USD").toUpperCase();

export const fmtCurrency = (n, currency = "USD") => {
  const sym = CURRENCY_SYMBOL[currency] || "$";
  const num = Number(n || 0);
  if (Math.abs(num) >= 1000000) return `${sym}${(num / 1000000).toFixed(1)}M`;
  if (Math.abs(num) >= 10000) return `${sym}${(num / 1000).toFixed(1)}k`;
  return `${sym}${num.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
};

export const fmtCurrencyFull = (n, currency = "USD") => {
  const sym = CURRENCY_SYMBOL[currency] || "$";
  const num = Number(n || 0);
  return `${sym}${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const fmtPct = (n) => `${Number(n || 0).toFixed(0)}%`;
export const fmtHours = (n) => `${Number(n || 0).toFixed(1)}h`;

export const statusExplanation = (status) => STATUS[status]?.description || "";

export const utilizationFillColor = (utilization) => {
  if (utilization > 100) return STATUS.losing_money.fillHex;
  if (utilization >= 86) return STATUS.close_to_limit.fillHex;
  return STATUS.on_track.fillHex;
};

export const utilizationFillClass = (utilization) => {
  if (utilization > 100) return STATUS.losing_money.fill;
  if (utilization >= 86) return STATUS.close_to_limit.fill;
  return STATUS.on_track.fill;
};
